// utils/api.js
export const fetchJobDetails = async (jobId) => {
    try {
       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/job/job/${jobId}`);
       if (!response.ok) {
         throw new Error("Failed to fetch job details");
       }
       return await response.json();
       
    } catch (error) {
       console.error("Error fetching job details:", error.message);
       throw error;
    }
   };
   // utils/api.js
export const fetchCompanyDetails = async (companyId) => {
    try {
       const response = await fetch(`http://localhost:8800/company/get-company/${companyId}`);
       if (!response.ok) {
         throw new Error("Failed to fetch company details");
       }
       return await response.json();
    } catch (error) {
       console.error("Error fetching company details:", error.message);
       throw error;
    }
   };
   